export default __webpack_public_path__ + "static/preview_300x620_HEVC-838d82f7d16a1b08abeb00857b7592b2.mp4";